import React from "react";
import style from "./style/Navbar.module.css"
import {NavLink} from "react-router-dom"

const Navbar = () => {
    return (
        <div className={style["navbar"]}>
            <nav className={style.nav}><NavLink to={"/"} className={style["hover-underline"]}>Home</NavLink></nav>
            <nav className={style.nav}><NavLink to={"/projects"} className={style["hover-underline"]}>Projects</NavLink></nav>
            <nav className={style.nav}><NavLink to={"/blog"} className={style["hover-underline"]}>Blog</NavLink></nav>
            <nav className={style.nav}><NavLink to={"/about"} className={style["hover-underline"]}>About</NavLink></nav>
        </div>
    )
}

export default Navbar;